import APIService from 'src/services/APIService'

const api = APIService()

export const getOrganisations = query => api.get(`/organisations?${query}`)
export const getOrganisationDetails = payload => api.get(`/organisations/${payload.id}`)
export const updateOrganisationSettings = (id, payload) =>
  api.patch(`/organisations/${id}/settings`, payload)
